import gql from 'graphql-tag';

import { LightModel } from '@/interfaces/LightModel';

export namespace DeviceModel {
  export const fragment = gql`
    fragment deviceModelFragment on LightModel {
      id
      brand
      name
      moduleNameId
      lifetime
      hasRatio
      fanSpeedSteps
      idlePowerConsumptionPerHour
      customPowerConsumptionAllowed
      temperatureMin
      temperatureMax
      minimumDimmingLevel
      hasSpaceSense
      hasAdjustableMinDimming
    }
  `;
  export type Definition = LightModel;
}
